<template>
    <div v-if="disabled">
        <v-text-field
                    v-model="date"
                    append-icon="mdi-calendar-month"
                    readonly
                    :label="label"
                    disabled
                />
    </div>
    <div v-else>
        <v-menu
            ref="refMenu"
            v-model="menu"
            :close-on-content-click="false"
            offset-y
            min-width="200"
        >
                <template v-if="!disabled"
                          v-slot:activator="{ on, attrs }">
                    <v-text-field
                        v-model="date"
                        :rules="rules"
                        append-icon="mdi-calendar-month"
                        readonly
                        :required="required"
                        :label="label"
                        v-bind="attrs"
                        v-on="on"
                    />
                </template>
                <template v-else>
                    <v-text-field
                        v-model="date"
                        :rules="rules"
                        append-icon="mdi-calendar-month"
                        readonly
                        :required="required"
                        :label="label"
                        disabled
                    />
                </template>
                <v-date-picker
                    v-model="date"
                    :locale="locale"
                    :day-format="d => new Date(d).getDate()"
                    :max="max"
                    :min="min"
                    @input="save"
                ></v-date-picker>
        </v-menu>
    </div>
</template>

<script>
export default {
    name: 'DateField',

    props: {
        value: String,
        label: String,
        required: Boolean,
        disabled: Boolean,
        rules: Array,
        max: String,
        min: String,
        locale: {
            type: String,
            default: 'ko-kr',
        }
    },

    data: () => ({
        menu: false,
        date: null,
    }),

    watch: {
        value(v) {
            this.date = v;
        }
    },

    methods: {
        save(date) {
            this.menu = false;
            this.$refs.refMenu.save(date);
            this.$emit('input', date);
        },
    }
}
</script>